const STORAGE_KEY_PREFIX = "medical-create-event:";

/**
 * Store a pending medical event in sessionStorage so navigation does not put a large
 * JSON blob in the URL (which blocks the main thread on parse and can hit URL limits).
 */
export function stashMedicalCreateEventPayload(event) {
  const key = `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
  sessionStorage.setItem(`${STORAGE_KEY_PREFIX}${key}`, JSON.stringify(event));
  return key;
}

/**
 * Read a pending medical event from sessionStorage (`eventKey`) or legacy `event` query param.
 */
export function readMedicalCreateEventPayload(searchParams) {
  const key = searchParams?.get?.("eventKey");
  if (key) {
    const raw = sessionStorage.getItem(`${STORAGE_KEY_PREFIX}${key}`);
    if (raw) {
      sessionStorage.removeItem(`${STORAGE_KEY_PREFIX}${key}`);
      try {
        return JSON.parse(raw);
      } catch {
        return null;
      }
    }
  }

  const legacy = searchParams?.get?.("event");
  if (!legacy) return null;
  try {
    return JSON.parse(legacy);
  } catch {
    return null;
  }
}

export function buildMedicalCreateFromRequestPath(event) {
  const key = stashMedicalCreateEventPayload(event);
  return `/medical/events/create-from-request?eventKey=${encodeURIComponent(key)}`;
}

export function navigateToMedicalCreateFromRequest(navigate, event) {
  navigate(buildMedicalCreateFromRequestPath(event));
}
